import { RefereeLicenseForm } from './components/referee-license-form';
import { Schema } from './components/referee-license-form.schema';
import { PageLayout } from '~/components/PageLayout/PageLayout';
import { useCreateRefereeLicenseMutation } from '../mutations';
import { withPrivateRoute } from '~/hocs/withPrivateRoute';
import { useRefereeQuery } from '~/pages/referee/queries';
import { endOfYear, formatDate } from '~/utils/date';
import { useParams } from '~/hooks/useParams';
import { Fragment } from 'react/jsx-runtime';
import { useNavigate } from 'react-router';
import { idParamSchema } from '~/schemas';

export const Page = withPrivateRoute(() => {
  const mutation = useCreateRefereeLicenseMutation();
  const navigate = useNavigate();

  const { id } = useParams(idParamSchema.parse);
  const { data } = useRefereeQuery(id);

  async function onSubmit(data: Schema) {
    await mutation.mutateAsync({ judge: id, ...data });
    navigate(`/referees/${id}/licenses`);
  }

  if (!data) {
    return false;
  }

  const start_date = formatDate(new Date(), 'yyyy-mm-dd');
  const end_date = formatDate(endOfYear(), 'yyyy-mm-dd');

  return (
    <Fragment>
      <PageLayout.Heading text="Skapa licens" />
      <PageLayout.SubHeading>{`${data.person.first_name} ${data.person.last_name}`}</PageLayout.SubHeading>

      <PageLayout.Section>
        <RefereeLicenseForm
          onSubmit={onSubmit}
          isLoading={false}
          mode="create"
          defaultValues={{
            club: [data.person.club.name, data.person.club.id],
            is_para: false,
            level: 'D',
            start_date,
            end_date,
          }}
        />
      </PageLayout.Section>
    </Fragment>
  );
});
